import Calc from './Calc';

document.querySelectorAll('[data-credit-calc]').forEach((element) => {
  new Calc(element, {});
});